// FormCreateBurger.jsx
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../styles/Admin.css";
import ImageUploader from "../../../../components/admin/ImageUploader";

const FormCreateBurger = ({ handleCreate }) => {
  const [imageUrl, setImageUrl] = useState(null);
  
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const burgerData = {
      ...data,
      photo_url: imageUrl
    };
    handleCreate(burgerData);
  };

  const handleImageUploaded = (url) => {
    setImageUrl(url);
  };

  return (
    <div className="container">
      <div className="burger-form-container mx-auto">
        <h3 className="text-center fw-bold products-title ">
          Crear Nueva Hamburguesa
        </h3>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <label className="form-label">Nombre de la Hamburguesa o Combo</label>
            <input
              type="text"
              className={`form-control ${errors.type_description ? "is-invalid" : ""}`}
              {...register("type_description", {
                required: "Este campo es obligatorio",
              })}
            />
            <div className="invalid-feedback" style={{ minHeight: "20px" }}>
              {errors.type_description?.message || ""}
            </div>
          </div>

          <div className="form-check mb-3">
            <input
              type="checkbox"
              className="form-check-input"
              {...register("side_fries")}
              id="sideFries"
            />
            <label className="form-check-label" htmlFor="sideFries">
              ¿Incluye Papas?
            </label>
          </div>

          <div className="mb-3">
            <label className="form-label">Color de fondo del botón</label>
            <input
              type="color"
              className={`form-control form-control-color ${errors.background_color ? "is-invalid" : ""}`}
              {...register("background_color", {
                required: "Selecciona un color de fondo",
              })}
              defaultValue="#198754"
              title="Elige el color de fondo para el botón de esta hamburguesa"
            />
            <div className="invalid-feedback" style={{ minHeight: "20px" }}>
              {errors.background_color?.message || ""}
            </div>
          </div>

          <ImageUploader
            currentImageUrl={null}
            onImageUploaded={handleImageUploaded}
          />

          <button type="submit" className="btn products-btn  w-100">
            Crear Hamburguesa
          </button>
        </form>
      </div>
    </div>
  );
};

export default FormCreateBurger;
